import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';

# Edit Users

- **Username** - needs to be unique, and not currently used on CanvasPro
- **Email** - needs to be a unique email not currently used on CanvasPro

## Password

If you need to edit the Password the tick the `Edit Password` box, the box will then appear.

- **Password** - take note of the password requirement

## Roles

You can change this User to another role.

## Saving or Cancelling

Once you've made your changes click <ExampleSaveButton /> (bottom right), or click <ExampleCloseButton /> (top right) to cancel.
